<script setup lang="ts">
  import type {BreadCrumbItem} from '~/composables/useCatalogBreadCrumb';

  definePageMeta({
    name: 'faq',
    layout: 'default',
  });

  const {b} = useCpBem('cp-faq');

  const breadcrumbItems: BreadCrumbItem[] = [
    {label: 'Centro de información', value: {name: 'information-center'}},
    {label: 'Preguntas frecuentes', value: ''},
  ];

  useSeoMeta({
    title: 'Preguntas frecuentes | Cyberpuerta.mx',
    description: 'Preguntas frecuentes',
    ogUrl: 'https://www.cyberpuerta.mx/Preguntas-frecuentes/',
    ogTitle: 'Preguntas frecuentes | Cyberpuerta.mx',
    ogDescription: 'Preguntas frecuentes',
  });
  useHead({
    link: [{
      rel: 'canonical',
      href: 'https://www.cyberpuerta.mx/Preguntas-frecuentes/',
    }],
  });
</script>

<template>
    <div :class="b">
        <CpBreadcrumb :items="breadcrumbItems" />
        <CpSectionMiscFaq kind="Purchase" />
        <CpSectionMiscFaq kind="Shipping" />
    </div>
</template>
